/**
 * Bundle Quantity Selector - FIXED SAVE CALCULATION
 * Now properly handles Pakistani Rupee formatting with commas
 */
class BundleQuantitySelector extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.buttons = this.querySelectorAll('.bundle-option');
    
    console.log('🎯 Bundle Selector Starting...');
    console.log('Form ID:', this.formId);
    
    // Find ALL possible quantity inputs
    this.quantityInputs = [
      document.querySelector(`#${this.formId}-quantity`),
      document.querySelector('input[name="quantity"]'),
      document.querySelector('.quantity-selector__input'),
      ...document.querySelectorAll('input[type="number"]')
    ].filter(Boolean);
    
    console.log('📊 Found quantity inputs:', this.quantityInputs.length);
    
    // Find the product form
    this.productForm = document.querySelector(`#${this.formId}`) 
                    || document.querySelector('form[action*="/cart/add"]');
    
    console.log('📝 Product form found:', !!this.productForm);
    
    // Find price elements - YOUR THEME SPECIFIC
    this.findPriceElements();
    
    // Set first bundle as active
    if (this.buttons.length > 0) {
      this.buttons[0].classList.add('active');
      this.updateEverything(this.buttons[0]);
    }
    
    // Add click handlers
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleClick(button);
      });
    });
    
    // Intercept form submission
    if (this.productForm) {
      this.interceptFormSubmission();
    }
  }
  
  findPriceElements() {
    // YOUR THEME uses custom elements
    this.mainPriceElement = document.querySelector('sale-price');
    this.comparePriceElement = document.querySelector('compare-at-price');
    this.saveBadgeElement = document.querySelector('on-sale-badge');
    
    console.log('💰 Price elements found:');
    console.log('  Main price (sale-price):', !!this.mainPriceElement);
    console.log('  Compare price (compare-at-price):', !!this.comparePriceElement);
    console.log('  Save badge (on-sale-badge):', !!this.saveBadgeElement);
    
    if (this.mainPriceElement) {
      console.log('  Current main price:', this.mainPriceElement.textContent);
    }
  }
  
  handleClick(button) {
    const quantity = parseInt(button.dataset.quantity) || 1;
    
    console.log('');
    console.log('='.repeat(50));
    console.log('🖱️ BUNDLE CLICKED');
    console.log('Quantity:', quantity);
    console.log('='.repeat(50));
    
    // Update active state
    this.buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    
    // Update everything
    this.updateEverything(button);
  }
  
  updateEverything(button) {
    const quantity = parseInt(button.dataset.quantity) || 1;
    const bundlePrice = button.dataset.bundlePrice;
    const bundleComparePrice = button.dataset.bundleComparePrice;
    
    // 1. Update ALL quantity inputs
    this.updateAllQuantities(quantity);
    
    // 2. Update price display (including save badge)
    this.updatePriceDisplay(bundlePrice, bundleComparePrice);
    
    // 3. Store current selection for form submission
    this.currentQuantity = quantity;
    this.currentPrice = bundlePrice;
  }
  
  updateAllQuantities(quantity) {
    console.log('📊 Updating quantities to:', quantity);
    
    let successCount = 0;
    
    this.quantityInputs.forEach((input, index) => {
      if (input) {
        // Set value
        input.value = quantity;
        input.setAttribute('value', quantity);
        
        // Dispatch events
        ['input', 'change', 'blur'].forEach(eventType => {
          input.dispatchEvent(new Event(eventType, { bubbles: true }));
        });
        
        console.log(`  ✓ Input ${index + 1} updated`);
        successCount++;
      }
    });
    
    console.log(`✅ Updated ${successCount} quantity input(s)`);
  }
  
  updatePriceDisplay(bundlePrice, bundleComparePrice) {
    console.log('💰 Updating price display...');
    console.log('  New main price:', bundlePrice);
    console.log('  New compare price:', bundleComparePrice);
    
    // Update main price (sale-price element)
    if (this.mainPriceElement && bundlePrice) {
      try {
        // Get the visible text content (excluding sr-only span)
        const srOnly = this.mainPriceElement.querySelector('.sr-only');
        
        if (srOnly) {
          // Keep sr-only span, update the rest
          const srOnlyHTML = srOnly.outerHTML;
          this.mainPriceElement.innerHTML = srOnlyHTML + bundlePrice;
        } else {
          // No sr-only span, just update text
          this.mainPriceElement.textContent = bundlePrice;
        }
        
        console.log('  ✅ Main price updated to:', bundlePrice);
        
        // Force repaint
        this.mainPriceElement.style.display = 'none';
        this.mainPriceElement.offsetHeight;
        this.mainPriceElement.style.display = '';
        
      } catch (e) {
        console.error('  ❌ Failed to update main price:', e);
      }
    } else {
      console.error('❌ Cannot update main price');
      console.log('  Element exists?', !!this.mainPriceElement);
      console.log('  Price value exists?', !!bundlePrice);
    }
    
    // Update compare-at price (strikethrough)
    if (this.comparePriceElement && bundleComparePrice && bundleComparePrice !== '0' && bundleComparePrice !== '') {
      try {
        const srOnly = this.comparePriceElement.querySelector('.sr-only');
        
        if (srOnly) {
          const srOnlyHTML = srOnly.outerHTML;
          this.comparePriceElement.innerHTML = srOnlyHTML + bundleComparePrice;
        } else {
          this.comparePriceElement.textContent = bundleComparePrice;
        }
        
        // Show the element
        this.comparePriceElement.style.display = '';
        
        console.log('  ✅ Compare price updated to:', bundleComparePrice);
        
      } catch (e) {
        console.error('  ❌ Failed to update compare price:', e);
      }
    } else if (this.comparePriceElement) {
      // Hide compare price if not provided
      this.comparePriceElement.style.display = 'none';
      console.log('  ℹ️ Compare price hidden (no value provided)');
    }
    
    // Update save badge - CALCULATE THE SAVINGS
    if (this.saveBadgeElement && bundlePrice && bundleComparePrice) {
      try {
        // Extract numeric values from prices
        const mainPrice = this.extractNumericValue(bundlePrice);
        const comparePrice = this.extractNumericValue(bundleComparePrice);
        
        console.log('  💵 Price extraction:');
        console.log('    Main price string:', bundlePrice);
        console.log('    Main price numeric:', mainPrice);
        console.log('    Compare price string:', bundleComparePrice);
        console.log('    Compare price numeric:', comparePrice);
        
        if (mainPrice && comparePrice) {
          const savings = comparePrice - mainPrice;
          
          console.log('    Savings calculation:', comparePrice, '-', mainPrice, '=', savings);
          
          if (savings > 0) {
            // Display savings as a percentage of the compare-at price
            const savingsPercent = Math.round((savings / comparePrice) * 100);
            const savingsText = `Save ${savingsPercent}%`;

            this.saveBadgeElement.textContent = savingsText;
            this.saveBadgeElement.style.display = '';

            console.log('  ✅ Save badge updated to:', savingsText);
          } else {
            this.saveBadgeElement.style.display = 'none';
          }
        } else {
          console.error('  ❌ Could not extract numeric values from prices');
        }
        
      } catch (e) {
        console.error('  ❌ Failed to update save badge:', e);
      }
    }
  }
  
  extractNumericValue(priceString) {
    // Handle Pakistani Rupee formatting: Rs.84,200.00 or Rs.96,200.00 / chair
    if (!priceString) return null;
    
    console.log('    Extracting from:', priceString);
    
    // Remove "Rs." prefix and everything after "/" (like "/ chair")
    let cleaned = priceString.replace(/Rs\./gi, '').split('/')[0].trim();
    
    // Remove all commas
    cleaned = cleaned.replace(/,/g, '');
    
    // Now it should be just the number with decimals
    const numeric = parseFloat(cleaned);
    
    console.log('    Cleaned string:', cleaned);
    console.log('    Parsed number:', numeric);
    
    return isNaN(numeric) ? null : numeric;
  }
  
  formatPakistaniRupees(amount) {
    // Format number with Pakistani Rupee style: Rs.84,200.00
    // Pakistani style uses commas for thousands
    const formatted = amount.toFixed(2);
    const parts = formatted.split('.');
    
    // Add commas to integer part
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    return 'Rs.' + parts.join('.');
  }
  
  interceptFormSubmission() {
    console.log('🔒 Form submission interceptor installed');
    
    const originalSubmit = this.productForm.submit.bind(this.productForm);
    const self = this;
    
    // Override form.submit()
    this.productForm.submit = function() {
      console.log('🚀 Form.submit() called');
      self.forceQuantityBeforeSubmit();
      return originalSubmit();
    };
    
    // Handle submit event
    this.productForm.addEventListener('submit', function(e) {
      console.log('🚀 Form submit event fired');
      self.forceQuantityBeforeSubmit();
    }, true);
    
    // Handle Add to Cart button clicks
    const addToCartButtons = this.productForm.querySelectorAll('[type="submit"], button[name="add"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        console.log('🛒 Add to Cart clicked');
        self.forceQuantityBeforeSubmit();
      }, true);
    });
  }
  
  forceQuantityBeforeSubmit() {
    if (this.currentQuantity) {
      console.log('');
      console.log('🔧 FORCING QUANTITY BEFORE SUBMIT:', this.currentQuantity);
      
      // Force update all quantity inputs one more time
      this.quantityInputs.forEach(input => {
        if (input) {
          input.value = this.currentQuantity;
          input.setAttribute('value', this.currentQuantity);
          console.log('  ✓ Forced input to:', input.value);
        }
      });
      
      // Also check if there's a hidden quantity input in the form
      const formQuantityInput = this.productForm.querySelector('input[name="quantity"]');
      if (formQuantityInput) {
        formQuantityInput.value = this.currentQuantity;
        console.log('  ✓ Form quantity input:', formQuantityInput.value);
      }
      
      console.log('✅ Quantity forced to:', this.currentQuantity);
    }
  }
}

// Register the custom element
if (!customElements.get('bundle-quantity-selector')) {
  customElements.define('bundle-quantity-selector', BundleQuantitySelector);
  console.log('✅ BundleQuantitySelector registered');
}

/**
 * Additional safety: Monitor quantity changes
 */
document.addEventListener('DOMContentLoaded', function() {
  console.log('🚀 Page loaded, monitoring quantities...');
  
  // Watch all quantity inputs
  const quantityInputs = document.querySelectorAll('input[name="quantity"]');
  quantityInputs.forEach((input, i) => {
    console.log(`📊 Quantity input ${i + 1} initial value:`, input.value);
    
    // Log when value changes
    input.addEventListener('change', function() {
      console.log(`📊 Quantity input ${i + 1} changed to:`, this.value);
    });
  });
});

/**
 * Sticky Gallery Stop Logic
 */
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 1000) {
    const lastAccordion = document.querySelector('.accordion-group .product-info__block-item:last-child');
    const gallery = document.querySelector('.product-gallery');
    
    if (lastAccordion && gallery) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.boundingClientRect.top < window.innerHeight) {
            gallery.style.position = 'relative';
            gallery.style.top = 'auto';
          } else {
            gallery.style.position = 'sticky';
            gallery.style.top = '100px';
          }
        });
      }, {
        threshold: [0, 0.5, 1],
        rootMargin: '0px 0px -20% 0px'
      });
      
      observer.observe(lastAccordion);
    }
  }
});